import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwRadioButtonModule } from '@cdw-ae/common-ui-components-radio-button';

import { CdwAutocompleteComponent } from './cdw-autocomplete/cdw-autocomplete.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialLibraryModule,
    CdwButtonModule,
    CdwCheckboxModule,
    CdwRadioButtonModule,
  ],
  declarations: [CdwAutocompleteComponent],
  exports: [CdwAutocompleteComponent],
})
export class CdwAutocompleteModule {}
